import * as React from 'react'

import { PlusIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { WorkflowStepType } from '~/client/graph'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'
import {
  workflowStepCategoriesMap,
  WorkflowStepCategory,
} from '~/client/src/shared/enums/WorkflowStepCategory'
import {
  getWorkflowCategoryDisplayName,
  getWorkflowStepDisplayName,
} from '~/client/src/shared/localization/enumDisplayTexts'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import WorkflowStepConfiguratorStore from '../WorkflowStepConfigurator.store'

// localization: translated

interface IProps {
  stepType: WorkflowStepType
  stepIdx: number

  store: WorkflowStepConfiguratorStore

  onAddStep(index: number, stepType: WorkflowStepType): void
}

const isApprovalCategory = (category: string): boolean =>
  category === WorkflowStepCategory.APPROVAL

@observer
export default class WorkflowAddStepModal extends React.Component<
  IProps,
  { isOpen: boolean }
> {
  public state = { isOpen: false }

  public render() {
    return (
      <div className="absolute-top m5">
        <Popover open={this.state.isOpen} onOpenChange={this.setOpen}>
          <PopoverTrigger
            nativeButton={false}
            render={
              <div className="tw:flex tw:items-center text large line-extra-large grey-30 pointer py6 px10 brada24 tw:data-popup-open:bg-accent" />
            }
          >
            <PlusIcon className="tw:size-4 tw:shrink-0" />
            <span className="nowrap ml3">
              {Localization.translator.addStep}
            </span>
          </PopoverTrigger>
          <PopoverContent
            side="bottom"
            align="start"
            className="tw:w-[240px] tw:overflow-hidden tw:p-0"
          >
            {this.stepModalContent}
          </PopoverContent>
        </Popover>
      </div>
    )
  }

  private get stepModalContent(): JSX.Element {
    const { stepType, stepIdx, store } = this.props

    return (
      <div className="col nowrap py8" onClick={this.close}>
        {Object.keys(workflowStepCategoriesMap).map(category => {
          const steps: WorkflowStepType[] = store.getModalStepOptions(
            stepType,
            stepIdx,
            workflowStepCategoriesMap[category],
          )
          if (!steps.length) return null

          return (
            <div
              key={category}
              className={classList({
                col: true,
                'bt-palette-brand-lighter': !isApprovalCategory(category),
              })}
            >
              <span className="text grey-30 small uppercase bold line-16 py4 px8">
                {getWorkflowCategoryDisplayName(
                  category as WorkflowStepCategory,
                )}
              </span>
              {steps.map(step => (
                <div
                  key={step}
                  className="row py10 px16 text large line-extra-large pointer highlighted-hover"
                  onClick={this.onStepClick.bind(this, step)}
                >
                  {getWorkflowStepDisplayName(step)}
                </div>
              ))}
            </div>
          )
        })}
      </div>
    )
  }

  private setOpen = (isOpen: boolean) => this.setState({ isOpen })

  private close = () => this.setOpen(false)

  private onStepClick(stepType: WorkflowStepType) {
    const { stepIdx, onAddStep } = this.props
    onAddStep(stepIdx, stepType)
  }
}
